import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

import { DEFAULT_COUNT_LAST_TRANSACTION } from '../../constants';
import TransactionsApi from '../../services/api/TransactionsApi';
import { TRANSACTION_FILTERS, TRANSACTION_TYPE } from '../../types';
import { RootState } from '../../types';
import { showError } from '../../utils/utils';

const setTransactionsHistoryLoading = createAction<{
  value: boolean;
  name: 'transactions' | 'getTransaction';
}>('transactions-history/setLoading');

const getTransactionsHistory = createAsyncThunk(
  'transactions-history/getTransactionsHistory',
  async (
    payload: {
      type: TRANSACTION_TYPE;
      countItems?: number;
    },
    thunkAPI
  ) => {
    try {
      thunkAPI.dispatch(
        setTransactionsHistoryLoading({ value: true, name: 'transactions' })
      );
      const store = thunkAPI.getState() as RootState;
      const { token, id: accountId } = store.auth.account;
      const countConst =
        payload.countItems === undefined
          ? DEFAULT_COUNT_LAST_TRANSACTION
          : payload.countItems;
      const response = await TransactionsApi.getLastTypeTransactions(token, {
        accountId,
        type: payload.type,
        count: countConst,
      });
      if (response.status === 200) {
        return response.data;
      }
    } catch (err) {
      showError(err, thunkAPI);
    } finally {
      thunkAPI.dispatch(
        setTransactionsHistoryLoading({ value: false, name: 'transactions' })
      );
    }
    return undefined;
  }
);

const getTransactionHistorySearch = createAsyncThunk(
  'transactions-history/search',
  async (payload: Omit<TRANSACTION_FILTERS, 'accountId'>, thunkAPI) => {
    const store = thunkAPI.getState() as RootState;
    const { token, id: accountId } = store.auth.account;
    try {
      thunkAPI.dispatch(
        setTransactionsHistoryLoading({ value: true, name: 'transactions' })
      );
      const response = await TransactionsApi.getSearchTransactions(token, {
        accountId,
        ...payload,
      });
      if (response.status === 200) {
        return response.data;
      }
    } catch (err) {
      showError(err, thunkAPI);
    } finally {
      thunkAPI.dispatch(
        setTransactionsHistoryLoading({ value: false, name: 'transactions' })
      );
    }
    return undefined;
  }
);

const getTransaction = createAsyncThunk(
  'transactions-history/getTransaction',
  async (payload: { transactionId: number }, thunkAPI) => {
    const store = thunkAPI.getState() as RootState;
    const accountId = store.auth.account.id;
    try {
      thunkAPI.dispatch(
        setTransactionsHistoryLoading({ value: true, name: 'getTransaction' })
      );
      const response = await TransactionsApi.getTransaction({
        accountId,
        transactionId: payload.transactionId,
      });
      if (response.status === 200) {
        return response.data;
      }
    } catch (err) {
      showError(err, thunkAPI);
    } finally {
      thunkAPI.dispatch(
        setTransactionsHistoryLoading({ value: false, name: 'getTransaction' })
      );
    }
    return undefined;
  }
);

export {
  getTransactionsHistory,
  getTransactionHistorySearch,
  setTransactionsHistoryLoading,
  getTransaction,
};
